import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Action, Store } from '@ngrx/store';
import * as Enumerable from 'linq';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';



@Injectable({ providedIn: 'root' })
export class RouterService {

  constructor(private router: Router, private store: Store<any>) {
    this.router
      .events
      .pipe(
        filter(event => event instanceof NavigationStart),
        map(event => this.router.routerState.root),
        map(this.getSnapshot),
        map(this.buildRouteData),
        distinctUntilChanged((x, y) => x.path === y.path)
      )
      .subscribe(data => {
        this.routerNavigatating(data);
      });

    this.router
      .events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(event => this.router.routerState.root),
        map(this.getSnapshot),
        map(this.buildRouteData),
        distinctUntilChanged((x, y) => x.path === y.path)
      )
      .subscribe(data => {
        this.routerNavigated(data);
      });
  }

  private getSnapshot(route: ActivatedRoute) {
    while (route.firstChild) route = route.firstChild;
    return route.snapshot;
  }

  private buildRouteData(data: ActivatedRouteSnapshot) {
    if (!data) return { path: '' };

    const paths = Enumerable.from(data.pathFromRoot)
      .where(x => x.url.length > 0)
      .select(x => x.url[0].path)
      .toArray();

    const component = '';

    const route = {
      path: '/' + paths.join('/'),
      url: Enumerable.from(paths).lastOrDefault(),
      params: data.params,
      queryParams: data.queryParams,
      data: data.data,
      component: component
    };

    return route;
  }

  static ROUTER_NAVIGATED = '[Application] Router Navigated';
  private routerNavigated(data, dispatch = true): Action {
    const action = {
      type: RouterService.ROUTER_NAVIGATED,
      payload: data
    };

    if (dispatch) this.store.dispatch(action);

    return action;
  }

  static ROUTER_NAVIGATING = '[Application] Router Navigating';
  routerNavigatating(data, dispatch = true): Action {
    const action = {
      type: RouterService.ROUTER_NAVIGATING,
      payload: data
    };

    if (dispatch) this.store.dispatch(action);

    return action;
  }
}
